module.exports = __webpack_public_path__ + "static/media/xmas-menu-2024.7e8d161e.pdf";